import type { IYouTrackProjectOption } from "../services/youtrackProjects.service";

export function formatYouTrackProjectLabel(shortName: string, name: string): string {
  const s = (shortName || "").trim();
  const n = (name || "").trim();
  if (s && n) {
    return `${s} — ${n}`;
  }
  return n || s || "";
}

export type YouTrackSelectOptionEntry = { value: string; label: string; disabled?: boolean };

export function buildYouTrackOptionEntriesForAdd(
  projects: IYouTrackProjectOption[],
): YouTrackSelectOptionEntry[] {
  return [
    { value: "", label: "— Wybierz projekt —", disabled: true },
    ...projects.map((p) => ({
      value: p.id,
      label: formatYouTrackProjectLabel(p.shortName, p.name),
    })),
  ];
}

export function buildYouTrackOptionEntriesForEdit(
  projects: IYouTrackProjectOption[],
  currentId: string | undefined,
  currentLabel: string | undefined,
): YouTrackSelectOptionEntry[] {
  const fromApi = projects.map((p) => ({
    value: p.id,
    label: formatYouTrackProjectLabel(p.shortName, p.name),
  }));
  const cur = (currentId ?? "").trim();
  if (cur && !fromApi.some((o) => o.value === cur)) {
    return [{ value: cur, label: (currentLabel ?? "").trim() || cur }, ...fromApi];
  }
  return fromApi;
}
